import React from 'react';
import { Box, Typography, Select, MenuItem, FormControl, SelectChangeEvent } from '@mui/material';
import { CornerBadge } from './CornerBadge.styles';
import { pointerCursorSx } from '../../helpers';

interface AppointmentTypeFieldProps {
  value: string | null;
  onChange: (value: string | null) => void;
  visible: boolean;
  required: boolean;
  isSelected: boolean;
  onClick: () => void;
  label?: string;
  options?: Array<{ text: string; value: string }>;
}

export const AppointmentTypeField: React.FC<AppointmentTypeFieldProps> = ({
  value,
  onChange,
  visible,
  required,
  onClick,
  label,
  options = [],
}) => {

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    if (!visible) return;
    onChange(event.target.value || null);
  };

  return (
    <Box
      onClick={onClick}
      position="relative"
      p={1}
      border={1}
      borderColor="divider"
      borderRadius={1}
      sx={{ cursor: 'pointer', opacity: visible ? 1 : 0.6 }}
    >
      {!visible && (
        <CornerBadge>HIDDEN</CornerBadge>
      )}
      <Typography variant="subtitle2" mb={1} color={visible ? 'inherit' : 'grey.500'}>
        {label || 'Calendar'} {required && <span style={{ color: 'red' }}>*</span>}
      </Typography>
      <Box onClick={onClick} sx={pointerCursorSx}>
        <FormControl fullWidth>
          <Select
            value={value || ''}
            onChange={handleSelectChange}
            onClick={(e) => e.stopPropagation()}
            disabled={false}
            sx={{
              opacity: visible ? 1 : 0.7,
              height: '55px',
            }}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value} disabled>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};
